<div class="persistant-snackbar__wrap">
  <h4>Opdatering klar – få de nyeste funktioner!</h4>
  <p>
    Genindlæs portalen for at undgå fejl ved indsendelse af data.<br />
    Du får samtidig adgang til den nyeste funktionalitet.
  </p>
  <button mat-raised-button type="button" (click)="reloadApp()"><mat-icon>refresh</mat-icon>Genindlæs</button>
</div>
